<template v-if="card">
  <div
    class="promoSlide"
    :style="styleAttributes"
  >
    <!-- Below Template for MCOM -->
    <div :class="['grid-x promoSlide-container ', promoClasses, globalClassAttributes]">
      <PromoFashion
        v-if="isFashionSlide"
        :data="card"
      />
      <PromoMarketShare
        v-if="isMarketShareSlide"
        :data="card"
      />
      <PromoValue
        v-if="isValueSlide"
        :data="card"
      />
      <PromoColumns
        v-if="isColumnSlide"
        :columns-data="card"
      />
      <PromoImageMap
        v-if="isImageMapSlide"
        :data="card"
      />
    </div>
  </div>
</template>

<script setup>
import {
  ref, onMounted, computed, provide, inject,
} from 'vue';
import { brand } from 'config';
import PromoFashion from './PromoFashion';
import PromoMarketShare from './PromoMarketShare';
import PromoValue from './PromoValue';
import PromoColumns from './PromoColumns';
import PromoImageMap from './PromoImageMap';
import {
  getClassAttributes,
  getStyleAttributes,
} from '../../helpers/getAttributes';

const props = defineProps({
  card: {
    type: Object,
    default: () => {},
  },
  index: {
    type: Number,
    default: 0,
  },
});
const currentPriority = inject('fetchPriority', false);
const fetchPriority = currentPriority && props.index < 1;
provide('fetchPriority', fetchPriority);

const globalClassAttributes = getClassAttributes(props.card?.attributes);
const brandClass = (brand === 'bcom') ? 'promoSlide-container-bcom' : 'promoSlide-container-mcom';
const promoClasses = computed(() => `promo-${props.card?.attributes?.slideType} ${brandClass}`);
const styleAttributes = ref({});
onMounted(() => {
  if (props.card?.attributes) {
    styleAttributes.value = getStyleAttributes(props.card?.attributes);
  }
});
const isMarketShareSlide = computed(() => {
  let cond = false;
  if (props.card?.attributes?.slideType === 'market-share-1' || props.card?.attributes?.slideType === 'market-share-2' || props.card?.attributes?.slideType === 'market-share-3' || props.card?.attributes?.slideType === 'market-share-4') {
    cond = true;
  }
  return cond;
});
const isValueSlide = computed(() => {
  let cond = false;
  if (props.card?.attributes?.slideType === 'value-1' || props.card?.attributes?.slideType === 'value-2' || props.card?.attributes?.slideType === 'value-3') {
    cond = true;
  }
  return cond;
});
const isFashionSlide = computed(() => {
  let cond = false;
  if (props.card?.attributes?.slideType === 'fashion-1' || props.card?.attributes?.slideType === 'fashion-2' || props.card?.attributes?.slideType === 'fashion-3' || props.card?.attributes?.slideType === 'fashion-4') {
    cond = true;
  }
  return cond;
});
const isColumnSlide = computed(() => {
  let cond = false;
  if (props.card?.attributes?.slideType === '4C8I' || props.card?.attributes?.slideType === '8I4C' || props.card?.attributes?.slideType === '6C6I' || props.card?.attributes?.slideType === '6I6C'
    || props.card?.attributes?.slideType === '7C5I' || props.card?.attributes?.slideType === '5I7C' || props.card?.attributes?.slideType === '5C7I' || props.card?.attributes?.slideType === '7I5C'
    || props.card?.attributes?.slideType === '4I4C4I' || props.card?.attributes?.slideType === 'full-image') {
    cond = true;
  }
  return cond;
});

const isImageMapSlide = computed(() => {
  let cond = false;
  if (props.card?.attributes?.slideType === 'image-map') {
    cond = true;
  }
  return cond;
});

const fontColor = props.card?.attributes?.fontColor ? props.card?.attributes?.fontColor : '';
</script>

<style lang="scss" scoped>
  .promoSlideshow-container {
    color: v-bind(fontColor);
    .componentCarousel {
      flex-direction: column;
    }
    .carousel-content {
      width: 100%;
    }
    .slide-show-pagination:after {
      background-color: transparent;
    }
    .slide-show-pagination-wrapper .slide-show-pagination {
      min-height: rem-calc(6px);
      max-height: rem-calc(6px);
    }
    .componentCarousel:has(.slide-show-pagination-wrapper) {
      .slide-show-container {
        margin-bottom: rem-calc(38px);
      }
    }
    .componentCarousel:not(:has(.slide-show-pagination-wrapper)) {
      .slide-show-container {
        margin-bottom: 0;
      }
    }
    @media only screen and (max-width:#{map-get($breakpoints, 'medium')-1}) {
      .slide-show-container {
        max-height: max-content;
      }
      .promoSlide-container {
        flex-direction: column;
      }
    }
    .promoSlide-container.promoSlide-container-mcom {
      flex-wrap: nowrap;
      position: relative;
      :deep() {
        .promoSlide-item-copy {
          justify-content: center;
          .promoSlide-item-copy-container {
            .logo-text-wrapper {
              display: flex;
              gap: rem-calc(24px);
            }
            .ctas-container {
              display: flex;
              flex-wrap: wrap;
            }
          }
        }
        .promoSlide-item {
          position: relative;
         //  display: flex;
          align-items: center;
          justify-content: center;
          .mainImageMap {
            position: relative;
            height: 100%;
          }
          .logo {
            position: absolute;
            z-index: 2;
          }
        }
      }
    }
    @media screen and (min-width: #{map-get($breakpoints, 'medium')}) and (max-width: #{map-get($breakpoints, 'large')-1}) {
      &.tablet .promoSlide-container-mcom {
        height: rem-calc(540px);
        overflow: hidden;
      }
      &.desktop .promoSlide-container-mcom {
        height: calc(100vw/2.776);
        overflow: hidden;
        &.promo-fashion-1, &.promo-fashion-3, &.promo-market-share-1, &.promo-value-1 {
          :deep() {
            .promoSlide-item {
              width: 48%;
              max-width: 48%;
              .mainImageMap {
                height: auto !important;
              }
            }
          }
        }
      }
    }
    @include breakpoint(medium down) {
      .promoSlide {
        height: 100%;
      }
    }
  }
</style>
<style lang="scss" brand="mcom">
@import './../../scss/globalAttributes.mcom.scss';
</style>

<style lang="scss" brand="bcom" scoped>
@import './../../scss/globalAttributes.bcom.scss';
</style>
